/* eslint-disable import/no-anonymous-default-export */
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { BUILD_ENV } from '@constants/build-env';
import rootReducer from '@store/slices';
import { AUTH_RESET } from './action-types';

const rootPersistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: [],
};

const reducer = combineReducers({
  root: persistReducer(rootPersistConfig, rootReducer),
});


const middlewares = [thunkMiddleware];


// purpose of appReduce is to reset redux store
// once AUTH_RESET action is dispatched
const appReducer = (state: TObject, action: TObject) => {
  if (action.type === AUTH_RESET) {
    state = undefined;
  }

  return reducer(state, action);
};

export const store = configureStore({
  reducer: appReducer,
  preloadedState: {},
  middleware: middlewares,
  devTools: process.env.REACT_APP_ENV !== BUILD_ENV.PRODUCTION,
});

// @ts-ignore
if (window?.Cypress) {
  // @ts-ignore
  window.store = store;
}

export type ReduxState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default () => {
  const persistor = persistStore(store);
  return { store, persistor };
};
